export const HEX_STYLE_BY_RESOLUTION = Object.freeze({
  3: Object.freeze({
    quantityDotRadiusStops: frozenStops([[0, 0], [1, 4], [25, 7], [75, 11], [150, 16], [246, 21]]),
  }),
  4: Object.freeze({
    quantityDotRadiusStops: frozenStops([[0, 0], [1, 4], [16, 7], [60, 11], [110, 16], [218, 21]]),
  }),
  5: Object.freeze({
    quantityDotRadiusStops: frozenStops([[0, 0], [1, 4], [6, 7], [18, 11], [33, 16], [103, 20]]),
  }),
  // At resolution 6, the deterministic 1,000-report dataset has a median of
  // two reports per occupied cell, a 90th percentile of eight, and a maximum
  // of 29. Fixed low-integer stops preserve useful differentiation.
  6: Object.freeze({
    quantityDotRadiusStops: frozenStops([[0, 0], [1, 4], [2, 7], [4, 11], [8, 16], [20, 20]]),
  }),
  // At resolution 7, most occupied cells contain one to three reports and the
  // deterministic maximum is eight, so each low count receives its own stop.
  7: Object.freeze({
    quantityDotRadiusStops: frozenStops([[0, 0], [1, 4], [2, 8], [3, 12], [4, 16], [8, 20]]),
  }),
});

export function hexStyleForResolution(resolution) {
  const style = HEX_STYLE_BY_RESOLUTION[resolution];
  if (!style) throw new RangeError(`No hex POC style is configured for H3 resolution ${resolution}.`);
  return style;
}

export const HEX_QUANTITY_MINIMUM_MAXIMUM = COUNT_SHADING_MINIMUM_MAXIMUM;
export const DEFAULT_HEX_QUANTITY_THRESHOLDS = DEFAULT_COUNT_SHADING_THRESHOLDS;
export const HEX_QUANTITY_FILL_STYLE = COUNT_SHADING_FILL_STYLE;

export const HEX_BOUNDARY_STYLE = Object.freeze({
  color: "#ffffff",
  opacity: 0.82,
  width: 1,
});

export const HEX_DOT_ONLY_BOUNDARY_STYLE = Object.freeze({
  color: "#0f172a",
  opacity: 0.9,
  width: 1.25,
});

export const HEX_REPORT_COUNT_DOT_STYLE = Object.freeze({
  color: "#b91c1c",
  strokeColor: "#ffffff",
  strokeWidth: 1.25,
  opacity: 0.9,
});

function frozenStops(stops) {
  return Object.freeze(stops.map(([value, output]) => Object.freeze([value, output])));
}
import {
  COUNT_SHADING_FILL_STYLE,
  COUNT_SHADING_MINIMUM_MAXIMUM,
  DEFAULT_COUNT_SHADING_THRESHOLDS,
} from "../count-shading.js";
